import { ModuleName } from "./types";
import { Areas } from "../components/Layout/types";

export const MODULES_AREA: Record<ModuleName, Areas> = {
  [ModuleName.AddressSearch]: Areas.MainControls,
  [ModuleName.BasemapSelect]: Areas.MainControls,
  [ModuleName.BookmarkControl]: Areas.MainControls,
  [ModuleName.Catalog]: Areas.Portal,
  [ModuleName.FeatureCard]: Areas.Main,
  [ModuleName.LayerList]: Areas.Panel,
  [ModuleName.SharedLayerList]: Areas.Panel,
  [ModuleName.Map]: Areas.Main,
  [ModuleName.MeasurerControl]: Areas.MainControls,
  [ModuleName.Notifications]: Areas.Portal,
  [ModuleName.Print]: Areas.TopControls,
  [ModuleName.ProjectPanel]: Areas.Panel,
  [ModuleName.ScaleControl]: Areas.MainControls,
  [ModuleName.DateFilterControl]: Areas.MainControls,
  [ModuleName.DateFilter]: Areas.AdditionalControls,
  [ModuleName.GeoLocation]: Areas.MainControls,
  [ModuleName.Style]: Areas.Panel,
  [ModuleName.StyleEditor]: Areas.Panel,
  [ModuleName.Dashboard]: Areas.Panel,
  [ModuleName.Presentation]: Areas.Presentation,
  [ModuleName.LayerConfiguration]: Areas.Panel,
  [ModuleName.ProjectConfiguration]: Areas.Panel,
  [ModuleName.ConfigurationsTable]: Areas.Bottom,
  [ModuleName.SymbolLibrary]: Areas.Panel,
  [ModuleName.Table]: Areas.Bottom,
  [ModuleName.Tools]: Areas.Panel,
  [ModuleName.Feedback]: Areas.Portal,
  [ModuleName.Help]: Areas.Portal,
  [ModuleName.Snapping]: Areas.TopControls,
  [ModuleName.ZoomSelection]: Areas.MainControls,
  [ModuleName.EqlQuery]: Areas.Panel,
  [ModuleName.EqlLayerTable]: Areas.Bottom,
  [ModuleName.EqlQueryTable]: Areas.Bottom,
};
